import moment from "moment";
import { SharedFileFragment as Row, SharedFilesFilter as Filter } from "@graphql";

export { Filter, Row };

export const initialFilter: Filter = {
  text: "",
  userIds: [],
  from: moment().startOf("year").toDate(),
  to: moment().startOf("year").add(1, "year").toDate()
};
